/* eslint-disable prettier/prettier */
<template>
  <div class="home">
    <header>
      <div class="header-container">
        <div class="image">
          <img src="../../src/assets/praxis-lambrette-home.png" alt="" />
        </div>
        <div class="text">
          <img
            class="logo"
            src="../../src/assets/praxis-lambrette-wortmarke.svg"
            alt="Logo"
          />
          <ul>
            <li>Fachpsychologin für Rechtspsychologie</li>
            <li>Supervisorin</li>
            <li>Psychologische Psychotherapeutin</li>
          </ul>
        </div>
      </div>
      <div class="bootstrap-wrapper teaser-container">
        <div class="container custom">
          <div class="row">
            <ul class="col-12 teaser">
              <li class="teaser-item teaser-item--1">
                <router-link to="/gutachten-im-familienrecht"
                  >Gutachten im<br />Familienrecht</router-link
                >
              </li>
              <li class="teaser-item teaser-item--2">
                <router-link to="/supervision-und-seminare"
                  >Supervision<br />und Seminare</router-link
                >
              </li>
              <li class="teaser-item teaser-item--3">
                <router-link to="/gutachten-im-waffenrecht"
                  >Gutachten im<br />
                  Waffenrecht</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>

    <Contact></Contact>
  </div>
</template>

<script>
import Contact from "../components/Contact.vue";

export default {
  components: {
    Contact
  },
  metaInfo: {
    title: "Dipl.-Psych. Katrin Lambrette – Gutachten & Supervision",
    meta: [
      {
        name: "description",
        content:
          "Fachpsychologin für Rechtspsychologie BDP/DGPs, Supervisorin IFT und Psychologische Psychotherapeutin"
      }
    ],
    htmlAttrs: {
      lang: "de",
      amp: true
    }
  }
};
</script>

<style lang="scss" scoped>
header {
  .header-container {
    .logo {
      display: none;
      max-width: 320px;
    }

    .info:first-child:after {
      content: "";
      display: inline-block;
      width: 100px;
      height: 20px;
      margin-left: -15px;
      border-bottom: 2px solid $brand-color;
    }
  }

  .teaser-container {
    .teaser {
      margin: 0;
      .teaser-item {
        margin-bottom: 1px;

        a {
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: "open_sansregular", sans-serif;
          font-size: 1.25rem;
          line-height: 1.75rem;
          color: $white;
          text-transform: uppercase;
          text-decoration: none;
          text-align: center;
          width: 100%;
          height: 140px;
        }

        &.teaser-item--1 a {
          background-color: rgba($familienrecht-color, 0.8);
        }
        &.teaser-item--2 a {
          background-color: rgba($supervision-color, 0.8);
        }
        &.teaser-item--3 a {
          background-color: rgba($waffenrecht-color, 0.8);
        }
      }
    }
  }

  @media screen and (min-width: 768px) {
    .teaser-container {
      .teaser {
        display: inline-flex;

        .teaser-item {
          width: 33.333%;
          margin-bottom: 0;
        }
      }
    }
  }

  @media screen and (min-width: 768px) and (max-width: 991px) {
    .header-container .image {
      align-items: flex-end;
    }
  }

  @media screen and (max-width: 991px) {
    .custom {
      max-width: 100% !important;
      .teaser {
        padding: 0 !important;
      }
    }
  }

  @media screen and (min-width: 992px) {
    .header-container {
      flex-direction: row-reverse;
      .text {
        background-image: url(../../src/assets/praxis-lambrette-home-signet-transparent.png);
        background-position: top left;
        padding: 0% 0 0 15%;
      }
      .logo {
        display: flex;
      }
    }

    .teaser-container {
      position: absolute;
      z-index: 1;
      bottom: 0;
      width: 100%;
    }
  }

  @media screen and (min-width: 1200px) {
    .header-container .text {
      padding: 5% 0 0 20%;
    }
  }
}
</style>
